import momencik from '../../../common/momencik';

export type DateRangeState = {
  dateFrom: string;
  dateTo: string;
};

const toInputDate = (date: Date): string => momencik(date, 'YYYY-MM-DD');

export const buildDefaultLastDaysRange = (days: number): DateRangeState => {
  const today = new Date();
  const dateTo = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );
  const dateFrom = new Date(dateTo);
  dateFrom.setDate(dateFrom.getDate() - (days - 1));

  return {
    dateFrom: toInputDate(dateFrom),
    dateTo: toInputDate(dateTo),
  };
};

export const resolveDefaultLastDaysRange = async (
  getReportLastDays: () => Promise<number | null | undefined>,
): Promise<DateRangeState> => {
  const days = await getReportLastDays();
  if (!days || days <= 0) {
    return buildCurrentMonthRange();
  }

  return buildDefaultLastDaysRange(days);
};

export const initDefaultLastDaysRange = async (
  getReportLastDays: () => Promise<number | null | undefined>,
  onRange: (range: DateRangeState) => void,
  onError: (error: unknown) => void,
): Promise<void> => {
  try {
    const range = await resolveDefaultLastDaysRange(getReportLastDays);
    onRange(range);
  } catch (error) {
    onError(error);
    onRange(buildCurrentMonthRange());
  }
};

export const buildCurrentMonthRange = (): DateRangeState => {
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  return {
    dateFrom: toInputDate(firstDay),
    dateTo: toInputDate(lastDay),
  };
};

export const toDateStart = (value: string): Date | undefined =>
  value ? new Date(`${value}T00:00:00Z`) : undefined;

export const toDateEnd = (value: string): Date | undefined =>
  value ? new Date(`${value}T23:59:59Z`) : undefined;
